// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3PmlF","bigColWidth":"Table_bigColWidth__2xHk3","biggerColWidth":"Table_biggerColWidth__2-MLs","row":"Table_row__iC3vu","col":"Table_col__1g0Ie"};